module.exports = __webpack_public_path__ + "img/declaration.67956ea1.jpg";